export var SDK_NAME = 'sentry.javascript.browser';
export var SDK_VERSION = '5.21.1';
//# sourceMappingURL=version.js.map


//////////////////
// WEBPACK FOOTER
// /home/forge/dev-client-app.instaveritas.com/releases/20231127121751/~/@sentry/browser/esm/version.js
// module id = ../../../../@sentry/browser/esm/version.js
// module chunks = 3